"use strict";

import angular from "angular";
/**
 * @component nuEmptyMessage
 * O <nu-empty-message> è um componente que é usado para mostrar uma menssage e também uma dica quando uma pesquisa não retorna sucesso
 * @this { scope.icon: "@" } Ícone
 * @this { scope.hint: "@" } Mensagem de dica abaixo do ícone
 * @this { scope.message: "@" } Mensagem abaixo da dica em font maior
 */

import template from "./empty-message.component.html";
import "./themes/empty-message.component.scss";
import "./themes/empty-message.component-dark.scss";

const name = "nuEmptyMessage";
const def = {
    bindings: {
        button: "=",
        hint: "@",
        icon: "@",
        message: "@"
    },
    controllerAs: "emptyMessage",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
